import styled from 'styled-components'

import Logo from '@lib/theme/images/LogoIconBlackAlpha.png'

export function SelectPackagePrompt() {
  return (
    <Container>
      <Img src={Logo} alt="Parameta Logo" />
      <h5>Select a data package</h5>
    </Container>
  )
}

const Img = styled.img`
  opacity: 0.25;
  width: 6rem;
  margin-bottom: 2rem;
`

const Container = styled.article`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
